import React from 'react';
import { FilterBadgeHookParams, PartnershipAdsBadgeHookResult } from '../types';

interface UsePartnershipAdsBadge extends FilterBadgeHookParams {
  compareWithPartnershipAds?: boolean;
}

export const usePartnershipAdsBadge = ({
  compareWithPartnershipAds = false,
}: UsePartnershipAdsBadge): PartnershipAdsBadgeHookResult => {
  const partnershipAdsBadge = React.useMemo(() => {
    if (!compareWithPartnershipAds) {
      return null;
    }

    return {
      value: 'compareWithPartnershipAds',
      label: 'Compare with Partnership Ads',
    };
  }, [compareWithPartnershipAds]);

  return {
    partnershipAdsBadgeProps: {
      data: partnershipAdsBadge ? [partnershipAdsBadge] : [],
    },
  };
};
